import React from "react";
import { Form, InputGroup, Modal, Button } from "react-bootstrap";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { RentSubscriptions } from "../../../Const";
import {
  usdtAddress,
  UsdtQRcode,
} from "../../../Const"
import { connect } from "react-redux";
import { useState } from "react";
import { sendRenewRentRequest } from "../../../actions/subscription-action";
import Loading from "../../common/Loading";
import useLoading from "../../hooks/useLoading";
import { useHistory } from "react-router-dom";
import useInput from "../../hooks/useInput";

const RenewBotRentCryptoModal = (props) => {
  const { show, onHide, sendEmail ,
    sendRenewRentRequest,template,plan,rent
  } = props;
  const [setLoading, bindLoading] = useLoading(false);
  //const address = network=='ERC'?usdtAddress.erc:usdtAddress.trc;
  //const qrcode = network=='ERC'?UsdtQRcode.erc:UsdtQRcode.trc;
  const [network,setNetwork] = useState('erc20')
  const [qrcode,setQrcode] = useState(UsdtQRcode.erc)
  const [address,setAddress] = useState(usdtAddress.erc)
  const [confirmPayment,setConfirmPayment] = useState(false)
  const [paymentCompleted,setPaymentCompleted] = useState(false)
  const [showContctFormButton,setShowContctFormButton] = useState(false)
  const [showconfirmPayment,setShowConfirmPayment] = useState(true)
  const [transactionId, bindTransactionId, resetTransactionId] = useInput("");
  const [adminNote, bindAdminNote, resetAdminNote] = useInput();
  const history = useHistory();
  const clickCopy = () => {
    copy(address);
    toast.success("Address copied.");
  };
  const changeNetwork = (network) => {
    setNetwork(network)
    setAddress((network=='erc20' || network=='bep20')?usdtAddress.erc:usdtAddress.trc)
    setQrcode((network=='erc20' || network=='bep20')?UsdtQRcode.erc:UsdtQRcode.trc)
  };
  const clickSendEmail = () => {
   //history.push('/bots');
    sendEmail();
  };
  const hideModal = () => {
    if(paymentCompleted)
    history.push('/bots?rental=true');
    onHide();
  };
  const clickPaymentDone = () => {
    if(!transactionId){
      toast.error('please enter transaction Id.')
      return false
    }
    setLoading(true)
    const params = {
      rent_id:rent.id,
      type:plan,
      payment_method:'usdt',
      usdt_address:address,
      usdt_network:network,
      note:adminNote,
      usdt_tnx:transactionId,
    };
    sendRenewRentRequest(params).then(()=>{
      setLoading(false)
      setShowContctFormButton(true)
      setShowConfirmPayment(false)
      setPaymentCompleted(true)
      toast.success('Your payment request has been received. You will receive an email once payment has been approved.')
      onHide();
    }).catch((err)=>{
      toast.error(err)
      setLoading(false)
      onHide()
    })
    
  };
  return (
    <Loading {...bindLoading}>
    <Modal show={show} onHide={hideModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title className="text-center">
          <img
            src={'/images/coins/USDT.png'}
            width={25}
            style={{ marginRight: 10 }}
          />
          Pay With USDT 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center" style={{ fontSize: 15 }}>
        <div className="mb-2 flex-evenly">
            <button className={network=='erc20'?'btn btn-primary':'btn btn-secondary'} onClick={()=>changeNetwork('erc20')}>USDT-ERC20</button>
            <button className={network=='trc20'?'btn btn-primary':'btn btn-secondary'} onClick={()=>changeNetwork('trc20')}>USDT-TRC20</button>
            <button className={network=='bep20'?'btn btn-primary':'btn btn-secondary'} onClick={()=>changeNetwork('bep20')}>USDT-BEP20</button>
        </div>
        <p>
          Please make a payment with{" "}
          <b>{template[RentSubscriptions[plan]]} USDT</b> to the
          following address:
        </p>
        <img src={qrcode} width={180} />
        <br />
        <div>
          <InputGroup>
            <Form.Control value={address} disabled style={{textAlign:'center'}}/>
            
         
            <InputGroup.Append>
              <Button variant="secondary" onClick={clickCopy}>
                Copy
              </Button>
            </InputGroup.Append>
          </InputGroup>
          <Form.Group>
            <Form.Label>Transaction ID</Form.Label>
            <Form.Control type="text" {...bindTransactionId} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Note to Admin</Form.Label>
            <Form.Control as="textarea" rows={3} size="lg" {...bindAdminNote} />
          </Form.Group>
          <br/>
          <p> <b>Please ensure that you bear all transfer charges. <br />Network: {(network=='erc20' || network== 'bep20')?'ERC20 or BEP20':'TRON TRC20'}</b></p>
        </div>
        <br />
        {showconfirmPayment && (
         <>
          <Form.Check
              label={
              <p>
                  Confirm you made payment
              </p>
              }
              className="terms"
              value={true}
              onChange={(e) => setConfirmPayment(e.target.checked)}
          /><br />
          <Button variant="success" onClick={clickPaymentDone} className={!confirmPayment?'disabled':''}>
            Payment Done
          </Button>
          </>
        )}
        {showContctFormButton && (
        <>
        <p>
          Email <a href="mailto:admin@cfdhero.com">admin@cfdhero.com</a>{" "}
          with the transaction ID and the user's account email to apply the
          payment to.
        </p>
        
        <Button variant="success" onClick={clickSendEmail}>
          Send Email
        </Button></> )}
        <br /> <br />
      </Modal.Body>
    </Modal>
    </Loading>
  );
};

export default connect(null, { sendRenewRentRequest })(RenewBotRentCryptoModal);
